<template>
  <span>{{ recurrence }}</span>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'recurrence'
    ])
  }
};
</script>



// WEBPACK FOOTER //
// recurrence.vue?5bf161ee